export default  {
  methods: {
    testMixinMethod(){
      console.log('this.mailsList::: from mailbox data ', this.mailsList); //from mailbox data
      console.log('this.getFilters()::: from mailbox methods ', this.getFilters()); //from mailbox methods
      console.log('this.accontsForDropdown::: from mailbox computed ', this.accontsForDropdown); //from mailbox computed
    }
  }
}